export default "__VITE_ASSET__f49ffe32__"